
const getCookie = (name) => {
  var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return value ? value[2] : null;
};
const isWebView = () => {
  const appVersion = getCookie('application_version');
  return appVersion != null;
};
const isAndroid = () => /Android/.test(window.navigator.userAgent);
export default {
  getCookie,
  isWebView,
  isAndroid,
};
